import React, { useState, useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Stack, Box, Typography, Collapse } from '@mui/material';
import Iconify from './Iconify';
import useMobile from '@/hooks/useMobile';

const ExpandMore = styled((props) => {
  const { expand, disabled, ...other } = props;
  return (
    <Box
      sx={{
        width: '16px',
        height: '16px',
        borderRadius: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme => disabled ? theme.palette.text.disabled : theme.palette.text.main
      }}
    >
      <Iconify
        width={14}
        height={14}
        icon={'mdi:keyboard-arrow-down'}
        {...other}
      />
    </Box>
  );
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ShowMoreCollapse({
  children,
  label = 'Más info',
  onChange = () => { },
  disabled
}) {
  const [expanded, setExpanded] = useState(false);

  const { isMobile } = useMobile();

  const handleExpandClick = (e) => {
    e.stopPropagation()
    if (disabled) return;
    setExpanded(!expanded);
  };

  useEffect(() => {
    onChange(expanded);
  }, [expanded]);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={0.5} onClick={handleExpandClick} sx={{ '&:hover': { cursor: !disabled ? 'pointer' : 'normal' } }}>
        <Box>
          <Typography
            variant="caption2"
            sx={{ flex: 1, color: '#6E6E73', fontSize: isMobile ? '12px' : '14px', lineHeight: '130%' }}
            component="div"
          >
            {label}
          </Typography>
        </Box>
        <Box>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            disabled={disabled}
          />
        </Box>
      </Stack>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
}
